<template>
  <Layout>
    <b-modal
        id="modalUpload"
        scrollable
        title="Subir archivo"
        title-class="font-1 8"
        size="lg"
        no-close-on-esc
        hide-footer
        centered
    >
      <subirArchivos v-on:upload-complete="uploadComplete" />
    </b-modal>
    <b-modal
        id="modalSalida"
        scrollable
        title="Salida del almacen"
        title-class="font-24"
        size="xl"
        hide-footer
    >
      <b-overlay :show="isLoadingModal" rounded="sm">
        <form class="needs-validation" @submit.prevent="submitForm">
        <b-tabs  card >
          <b-tab title="Datos" active>
              <div class="row">
                  <div class="form-group col-md-9">
                    <label>Expediente</label>
                    <v-select
                        :options="expedientes"
                        label="obra_expediente"
                        :reduce="desc=>desc.expediente_id"
                        v-model="model.expediente_id"
                        :class="{ 'is-invalid': submittedSalida && $v.model.expediente_id.$error }"
                        @input="cargarRecursos()"
                        :disabled="deshabilitar_formulario"
                    />
                    <div v-if="submittedSalida && $v.model.expediente_id.$error" class="invalid-feedback">
                      <span v-if="!$v.model.expediente_id.required">Este valor es requerido.</span>
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Fecha</label>
                    <VueCtkDateTimePicker
                        v-model="model.fecha"
                        :locale="'es'"
                        :input-size="'sm'"
                        :format="'YYYY-MM-DD'"
                        :formatted="'YYYY-MM-DD'"
                        :range="false"
                        :auto-close="true"
                        :only-date="true"
                        :no-header="true"
                        :class="{ 'is-invalid': submittedSalida && $v.model.fecha.$error }"
                        style="z-index: 100"
                        :disabled="deshabilitar_formulario"
                    />
                    <!--style="position: fixed;width: 180px-->
                    <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"-->
                    <div v-if="submittedSalida && $v.model.fecha.$error" class="invalid-feedback">
                      <span v-if="!$v.model.fecha.required">Este valor es requerido.</span>
                    </div>
                  </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Recurso</label>
                  <v-select
                      :options="recursos"
                      label="recurso"
                      v-model="recurso_actual"
                      :disabled="deshabilitar_formulario"
                  />
                </div>
              </div>
              <div class="row">

                <div class="form-group col-md-3">
                  <label>Nº Documento</label>
                  <input class="form-control" readonly="true" v-model="recurso_actual.numero_documento" />
                </div>
                <div class="form-group col-md-2">
                  <label>PU</label>
                  <input class="form-control" readonly="true" v-model="recurso_actual.precio_unitario" />
                </div>
                <div class="form-group col-md-2">
                  <label>UdeM</label>
                  <input class="form-control" readonly="true" v-model="recurso_actual.unidad_medida" />
                </div>
                <div class="form-group col-md-2">
                  <label>Cantidad</label>
                  <input class="form-control" v-model="recurso_actual.cantidad" />
                </div>
                <div class="form-group col-md-2">
                  <button class="btn btn-primary mt-4"
                          type="button"
                          :disabled="deshabilitar_formulario"
                          v-on:click="agregarDetalle"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar</button>

                </div>

              </div>
              <!--<div class="row">
                <div class="form-group col-md-3">
                  <label>Tipo de entrada</label>
                  <select
                      class="form-control"
                      v-model="model.tipo"
                      :class="{ 'is-invalid': submittedSalida && $v.model.tipo.$error }"
                      :disabled="deshabilitar_formulario"
                  >
                    <option value="20">Orden de compra</option>
                    <option value="30">NEA (Nota de entrada de almacen) </option>
                    <option value="300">Otros</option>
                  </select>
                  <div v-if="submittedSalida && $v.model.tipo.$error" class="invalid-feedback">
                    <span v-if="!$v.model.tipo.required">Este valor es requerido.</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Número</label>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control"
                           placeholder="Ingrese el número"
                           aria-describedby="button-addon2"
                           v-model="model.numero_documento"
                           :disabled="deshabilitar_formulario"
                    >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary"
                              type="button"
                              id="button-addon2"
                              v-on:click="buscarDocumento"
                              :disabled="deshabilitar_formulario"
                      >
                        <i class="fa fa-search"></i>
                        Buscar
                        <b-spinner small v-show="loadingDocumento"></b-spinner>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Pecosa</label>
                  <input type="text"
                         class="form-control"
                         v-model="model.pecosa"
                         :disabled="deshabilitar_formulario"
                         :class="{ 'is-invalid': submittedSalida && $v.model.pecosa.$error }"
                  />
                  <div v-if="submittedSalida && $v.model.pecosa.$error" class="invalid-feedback">
                    <span v-if="!$v.model.pecosa.required">Este valor es requerido.</span>
                  </div>
                </div>
              </div>-->

            <h4>Lista</h4>
            <div class="row">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>Recurso ID</th>
                  <th>Nombre</th>
                  <th>UdM</th>
                  <th>Cantidad </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in model.detalles"  v-bind:key="index">
                  <td>{{data.recurso_id}}</td>
                  <td>{{data.nombre}}</td>
                  <td>{{data.unidad_medida}}</td>
                  <td>
                    <input class="form-control" v-model="data.cantidad" :disabled="deshabilitar_formulario">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab title="Documentos">


          </b-tab>
        </b-tabs>
        <div class="row">
          <div class="col-md-12 text-right">
            <button class="btn btn-primary mr-2" type="submit" :disabled="deshabilitar_formulario">
              <i class="fa fa-save"></i>
              Guardar y mover al almacen</button>
            <button class="btn btn-outline-secondary"
                    type="button"
                    v-on:click="cerrarFormulario"
            >

              <i class="fa fa-door-closed"></i>
              Salir</button>
          </div>
        </div>
        </form>
      </b-overlay>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <button  type="button" class="btn btn-primary mb-3" v-on:click="nuevo">Nuevo</button>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Expediente</label>
        <v-select
            :options="expedientes"
            label="obra_expediente"
            :reduce="desc=>desc.expediente_id"
            v-model="expediente_id"
            @input="loadItems()"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Buscar</label>
        <div class="input-group">
          <input
              type="text"
              v-model="terminoBusqueda"
              class="form-control"
              placeholder="Buscar por numero de documento, concepto, monto."
              @input="buscarPorTermino"
          >
          <!--<div class="input-group-append">
            <button class="input-group-text" v-on:click="loadItems" >Buscar</button>
            <button class="input-group-text" v-on:click="loadItems" >Borrar</button>
          </div>-->
        </div>
      </div>
    </div>
    <vue-good-table
        ref="tabla"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        @on-search="onSearch"
        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        :pagination-options="{
              enabled: true,
              }"
        :rows="rows"
        :columns="columns"

        styleClass="vgt-table striped smalltable"

    >
      <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
              <button class="btn btn-success btn-icon btn-sm mr-1"
                      v-on:click="ver(props.row.id)"
                      v-show="$can('am-entrada-ver')"
              ><i class="fa fa-eye"></i></button>
              <button class="btn btn-primary btn-icon btn-sm mr-1"
                      v-on:click="ver(props.row.id)"
                      v-show="$can('am-entrada-ver')"
              ><i class="fa fa-print"></i></button>

              <!--<button class="btn btn-primary btn-icon btn-sm" v-on:click="modificar(props.row.id)"><i class="fa fa-edit"></i></button>-->
              <button class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrar(props.row.id)"><i class="fa fa-trash"></i></button>

            </span>
        <span v-else>
              {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import subirArchivos from "@/components/subir-archivos.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Salidas del almacen",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    subirArchivos,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Salidas del almacen",
      items: [
        {
          text: "Finanzas",
          href: "/",
        },
        {
          text: "Pagos",
          active: true,
        },
      ],

      isLoading: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Recursos',
          field: 'recursos',
        },
        {
          label: 'Tipo',
          field: 'tipo_str',
        },
        {
          label: 'Fecha',
          field: 'fecha',
        },
        {
          label: 'Usuario',
          field: 'usuario',
        },
        {
          label: 'Acciones',
          field: 'acciones',
          width: '15%'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      isLoadingModal:false,
      disable_monto:false,
      disable_ruc:false,
      disable_denominacion:false,
      disable_clasificador:false,
      submittedSalida:false,
      model:{
        id:0,
        expediente_id:null,
        tipo:null,
        detalles:[]
      },
      expedientes:[],
      server:process.env.VUE_APP_BACKEND,
      loadingDocumento:false,
      recurso_actual:{},
      unidades_medida:[],
      deshabilitar_formulario:false,
      documento_tipo_subir:null,
      recursos:[],
      terminoBusqueda:"",
      expediente_id:null

    };
  },

  methods: {
    buscarPorTermino(){
      clearTimeout(this.debounceTimer);
      // Establecer un nuevo temporizador de medio segundo
      this.debounceTimer = setTimeout(() => {
        this.serverParams.page=1;
        this.$refs['tabla'].reset();
        //this.$refs['tabla'].reset();
        this.loadItems();
        // Aquí puedes realizar las acciones que necesites
      }, 500); //
    },
    formatSize(bytes){
      return this.$formatSize(bytes);
    },
    agregarDetalle(){

      this.model.detalles.push({
        'recurso_id':this.recurso_actual.recurso_id,
        'nombre':this.recurso_actual.nombre,
        'cantidad':this.recurso_actual.cantidad,
        'unidad_medida':this.recurso_actual.unidad_medida,
        'unidad_medida_id':this.recurso_actual.unidad_medida_id,
        'subtotal':this.recurso_actual.subtotal,
        'gasto_detalle_id':this.recurso_actual.gasto_detalle_id,
        'precio_unitario':this.recurso_actual.precio_unitario
        //'clasificador':this.recurso_actual.clasificador.nombre,
        //'clasificador_id':this.recurso_actual.clasificador.id,
      })
    },
    cerrarFormulario(){
      this.$bvModal.hide("modalSalida");
    },
    borrarDetalle(){

    },
    cargarRecursos(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND+"/api/gastos/recursos/"+this.model.expediente_id)
          .then((response)=>{
            this.recursos=response.data;
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los recursos",'warning');
          })
          .finally(()=>{
            this.isLoadingModal=false;
          })
    },
    buscarDocumento(){
      if(this.model.expediente_id==null){
        this.$swal('Cuidado!',"Seleccione un expediente",'warning');
        return;
      }
      if(!this.$isNumeric(this.model.numero_documento)){
        this.$swal('Cuidado!',"Solo se acepta numeros",'warning');
        return;
      }
      if(parseInt(this.model.tipo)==20){
        this.isLoadingModal=true;
        this.axios.get(process.env.VUE_APP_BACKEND+"/api/orden-compra/buscar/"+this.model.numero_documento)
            .then((response)=>{
              this.model.detalles=response.data.detalles;
              this.model.detalles.forEach((item)=>{
                item.cantidad_global=item.cantidad;
                //item.cantidad=item.cantidad;
              })
            })
            .catch(()=>{
              this.$swal('Cuidado',"Error cargando la orden de compra",'warning');
            })
            .finally(()=>{
              this.isLoadingModal=false;
            })

      }
      else {
        this.$swal('Cuidado',"No implementado",'warning');
      }
    },
    uploadComplete(files){
      this.isLoading=true;
      this.$bvModal.hide("modalUpload");
      //files[0]['documento_tipo']=this.documento_tipo_subir;
      //this.gasto.archivos.push(files[0]);
      this.axios.post(process.env.VUE_APP_BACKEND + "/api/almacen/salidas/archivos",
          {
            files:files,
            documento_tipo:this.documento_tipo_subir,
            entrada_id:this.model.id
          })
          .then(()=>{
            //this.gasto=response.data.model;
            this.$bvModal.hide("modalUpload");
            this.actualizar();
          })
          .finally(()=>this.isLoading=false)
    },
    actualizar(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/almacen/salidas/"+this.model.id)
          .then((response)=>{
            this.model=response.data;
            //this.$bvModal.show("modalSalida");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    abrirCarga(){
      this.$bvModal.show("modalUpload");
    },
    submitForm(){
      this.submittedSalida = true;
      // stop here if form is invalid
      //this.$v.$touch();
      this.$v.model.$touch();
      if(this.$v.model.$error===false){
        this.guardar();
      }
      else
      {
        this.$swal('Cuidado',"Formulario no valido",'warning');
      }
    },
    nuevo(){
      this.deshabilitar_formulario=false;
      this.submittedSalida=false;
      this.model={
        id:0,
        expediente_id:null,
        detalles:[],
        archivos:[]
      };
      this.$bvModal.show("modalSalida");

    },
    ver(id){
      this.isLoading=true;
      this.recurso_actual={};
      this.deshabilitar_formulario=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/almacen/salidas/"+id)
          .then((response)=>{
            this.model=response.data;
            this.metas=response.data.metas;
            this.$bvModal.show("modalSalida");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    modificar(id){
      this.isLoading=true;
      this.recurso_actual={};
      this.deshabilitar_formulario=false;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/almacen/salidas/"+id)
          .then((response)=>{
            this.model=response.data;
            this.metas=response.data.metas;
            this.$bvModal.show("modalSalida");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    guardar(){
      this.isLoadingModal = true;
      const request = this.model.id != 0
          ? this.axios.put(`${process.env.VUE_APP_BACKEND}/api/almacen/salidas/${this.model.id}`, this.model)
          : this.axios.post(`${process.env.VUE_APP_BACKEND}/api/almacen/salidas`, this.model);
      request
          .then(() => {
            this.$bvModal.hide("modalSalida");
            this.loadItems();
            //this.actualizar();
          })
          .catch(() => {
            this.$swal('Cuidado', "Error", 'warning');

          })
          .finally(() => {
            this.isLoadingModal = false;
          });

    },
    decimal(value) {
      if (value === null) {
        return '-'
      } else {
        return parseFloat(value).toFixed(2)
      }
    },
    borrarArchivo(id){
      this.$swal.fire({
        title: '¿Esta seguro de borrar el archivo?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoadingModal=true;
          this.axios.delete(process.env.VUE_APP_BACKEND +'/api/almacen/salidas/'+this.model.id+'/archivos/'+id)
              .catch(()=>{
                this.$swal('error','Error eliminando','error');
              })
              .finally(
                  ()=>
                  {
                    this.isLoadingModal=false;
                    this.actualizar();
                  }

              );
        }
      })
    },
    borrar(id) {
      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.axios.delete(process.env.VUE_APP_BACKEND + '/api/almacen/salidas/' + id)
              .catch(() => {
                this.$swal('error', 'Error eliminando', 'error');
              })
              .finally(
                  () => {
                    this.isLoading = false;
                    this.loadItems();
                  }
              );
        }
      })

    },
    onSearch: function (params) {
      this.updateParams({page: params.page});
      this.updateParams({searchTerm: params.searchTerm});
      this.loadItems();
    },
    say: function (message) {
      alert(message)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [{
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        }],
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.terminoBusqueda=this.terminoBusqueda;
      this.serverParams.expediente_id=this.expediente_id;
      this.axios.get(process.env.VUE_APP_BACKEND + '/api/almacen/salidas/tabla', {'params': this.serverParams})
          .then((response) => {
            //console.log(response.data.data);
            this.totalRecords = response.data.total_records;
            this.rows = response.data.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            //console.log(error);
          });
    },

  },
  mounted() {
    this.$cargarExpedientes( (res)=>{
      this.expedientes=res.data
      if(this.expedientes.length>0){
        this.expediente_id=this.expedientes[0].expediente_id;
        this.loadItems();
        //this.actualizar();
      }
    },()=>{});


    this.$cargarClasificadores( (res)=>{
      this.clasificadores=res.data
    },()=>{});
    this.$cargarUnidadesMedida( (res)=>{
      this.unidades_medida=res.data
    },()=>{});
  },
  validations: {
    model:{
      expediente_id:{required},
      fecha:{required}
    },

  },
};
</script>

<style>
.smalltable {
  font-size: 12px !important;
}
</style>
